module.exports = __webpack_public_path__ + "static/img/8.5ed62ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/7/1/zh/8.png
// module id = +mKn
// module chunks = 0